import DateUtils from "../../../../utils/date_utils";
import { type } from "os";

export const parseDate = (value) => {		
	if (value === null || value === undefined || value === '') {
		return "";
	}

	return DateUtils.convertDateStringToISOString(value);
};

export const parseTextArea = (value) => {
	if (value === null || value === undefined) {
		return "";
	}

	return value !== " " ? value : "";
};

export const convertUndefinedValueToEmpty = (value) => {			
	return (value || value === 0) ? value : "";
};

export const parseAutoComplete = (value) => {
	if ((Array.isArray(value) && !value.length) || (Array.isArray(value) && value.length && !value[0])) {
		return "";
	}

	return (value || value === 0) ? value : "";
};

const FieldTypeOperandParser = {
	DATE: (fieldAPI, property) => parseDate(fieldAPI[property]()),
	TEXTAREA: (fieldAPI, property) => parseTextArea(fieldAPI[property]()),
	DEFAULT: (fieldAPI, property) => convertUndefinedValueToEmpty(fieldAPI[property]()),
	AUTOCOMPLETE: (fieldAPI, property) => parseAutoComplete(fieldAPI[property]()),
};

export const parse = (fieldAPI, property) => {
	if(!fieldAPI)
		throw new Error(`form.errors.behavior.action.invalid_element`);

	var parser = FieldTypeOperandParser[fieldAPI.type()] || FieldTypeOperandParser['DEFAULT'];
	return parser(fieldAPI, property);
};

export default {
	parse
}
